<template>
    <div class="background">
        <div>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Top/>
                </el-col>
            </el-row>
            <el-row class="row-main">
                <el-col :span="14" :offset="5" class="col-main">
                    <div class="div-main">
                        <h3>网站导航</h3>
                        <el-row>
                            <el-link type="primary" href="/#/ProductList">药品列表</el-link>&emsp;药品信息查询
                        </el-row>
                        <el-row>
                            <el-link type="primary" href="/#/HotNews">聚美头条</el-link>&emsp;企业行业资讯
                        </el-row>
                        <el-row>
                            <el-link type="primary" href="/#/License">许可证书</el-link>&emsp;药品经营许可证
                        </el-row>
                        <el-row>
                            <el-link type="primary" href="/#/Record">网络备案</el-link>&emsp;互联网药品信息服务备案
                        </el-row>
                        <el-row>
                            <el-link type="primary" href="/#/ContactUs">联系我们</el-link>&emsp;公司地址电话
                        </el-row>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Footer/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import Top from './Top';
import Footer from './Footer';
export default {
    name: 'Navigition',
    data() {
        return {
            list : [],
            drawer : false,
            news_title : "",
            news_detail : ""
        }
    },
    components: {
        'Top' : Top,
        'Footer' : Footer
    },
    mounted () {
        const _this = this;
        var hotNewsList;
        this.$axios
            .get('../static/json/hotNewsList.json')
            .then(response => (
                hotNewsList = response.data.data,
                this.list = hotNewsList
            ));
    },
    methods: {
        /* 弹出抽屉 */
        showDrawer(index){
            this.drawer = true;
            this.news_title = this.list[index].news_title,
            this.news_detail = this.list[index].news_detail
        }
    }
}

</script>

<style scoped>
/** 主组件DIV背景,高度铺满页面主DIV */
.background{
    height: 100%;
    /* background: url('https://bing.biturl.top/?resolution=1920&format=image&index=0&mkt=zh-CN'); */
}
.background>div{
    background-color:  rgba(255, 255, 255, 0.5);
    height: 100%;
}
.el-link{
    font-size: 20px;
    line-height: 40px;
}
.row-main{
    height:80%;
    margin: 10px auto;
}
.col-main,.div-main{
    height: 100%;
}
.div-main{
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
}
.pdf-link{
    font-size: 20px;
    line-height: 40px;
    color: #409EFF;
    text-decoration: none;
}
.pdf-link:hover{
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/Navigition.vue